import { render, staticRenderFns } from "./change-password-email.vue?vue&type=template&id=5558e3a6&scoped=true"
import script from "./change-password-email.vue?vue&type=script&lang=js"
export * from "./change-password-email.vue?vue&type=script&lang=js"
import style0 from "./change-password-email.vue?vue&type=style&index=0&id=5558e3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5558e3a6",
  null
  
)

export default component.exports